import * as React from 'react';
import MuiPopover from '@mui/material/Popover';
import type { PopoverActions, PopoverOrigin } from '@mui/material/Popover';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';

interface IProps {
  open: boolean;
  anchorEl?: null | Element | (() => Element);
  onClose?: React.ReactEventHandler<Record<string, never>>;
  children?: React.ReactNode;
  keepMounted?: boolean;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
  className?: string;
  style?: React.CSSProperties;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  action?: React.Ref<PopoverActions>;
}

const styles = (theme: Theme) => ({
  /** Styles applied to the Paper component */
  paper: {},
});

export const EDPopover: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = (props: IProps) => {
  return (
    <MuiPopover
      open={props.open}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      anchorOrigin={
        props.anchorOrigin ?? { horizontal: 'left', vertical: 'bottom' }
      }
      transformOrigin={
        props.transformOrigin ?? { horizontal: 'center', vertical: 'top' }
      }
      slotProps={{ paper: { style: props.style } }}
      classes={props.classes}
      className={props.className}
      keepMounted={props.keepMounted}
      action={props.action}
    >
      {props.children}
    </MuiPopover>
  );
};

export { PopoverActions };
export default withStyles(EDPopover, styles);
